import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import useSnackBar from "../../../../../components/Commons/SnackBar/useSnackBar";
import { Menuitem } from "../../../../../interfaces/Security/menu";
import GenericPromises from "../../../../../api/GenericPromises";
import { ProjectTemplate } from "../../../../../interfaces/Projects/Catalogs/Templates/projectsTemplate";
import { Spinner } from "../../../../../components/Commons/Spinner/Spinner";
import { GenericDialog } from "../../../../../components/Dialogs/Dialog";
import { ButtonStyled } from "../../../../../theme/buttons";
import { Button } from "@mui/material";
import { Header } from "../../../../../components/Header";
import { TableProjectStagesTemplate } from "../ProjectStagesTemplate/table";
import TabsProjectsTemplateDetails from "./tabsDetails";
import { ProjectExtraFieldTemplate } from "../../../../../interfaces/Projects/Catalogs/Templates/projectExtraFieldsTemplate";
import { usePermissions } from "../../../../../hooks/usePermissions";
import { TableProjectExtraFieldsTemplate } from "../ProjectExtraFieldsTemplate/table";
import { useBase64 } from "../../../../../hooks/useBase64";
import { FieldType } from "../../../../../interfaces/Projects/Catalogs/fieldTypes";

export const ViewProjectsTemplate = () => {
  const [t] = useTranslation("global");
  const location = useLocation();
  const navigate = useNavigate();
  const [projectsTemplateLocal, setProjectsTemplateLocal] =
    useState<ProjectTemplate>();
  const { GetResourceByUrl } = usePermissions();
  const [openDialog, setOpenDialog] = useState(false);
  const [dataloaded, setDataLoaded] = useState(false);
  const { GenericGetResource, GenericDeleteResource } = GenericPromises();
  const [resourceScreen, setResourceScreen] = useState<Menuitem>();
  const { showSnackBar, SnackbarComponent } = useSnackBar();
  const [projectExtraFieldsTemplateData, setProjectExtraFieldsTemplateData] = useState<ProjectExtraFieldTemplate[]>([]);
  const [comboFieldTypes, setComboFieldTypes] = useState<FieldType[]>([]);
  const { utf8ToBase64 } = useBase64();

  const onDelete = async () => {
    GenericDeleteResource(
      `/projectstemplate/${projectsTemplateLocal?.project_template_id}`
    )
      .then(() => {
        setOpenDialog(false);
        navigate("/projectstemplate", {
          state: { method: "delete" },
          replace: true,
        });
      })
      .catch((error) => {
        showSnackBar(error.message, "error");
        setOpenDialog(false);
      });
  };

  useEffect(() => {
    if (location.state === null)
      return navigate("/projectstemplate", { state: {}, replace: true });
    GenericGetResource(
      `/projectstemplate/${location.state.row.project_template_id}`
    )
      .then(async (responseProjectTemplate) => {
        setProjectsTemplateLocal(responseProjectTemplate.data);

        let myPromises = [
          GenericGetResource(`/projectextrafieldstemplate/byprojecttemplateid/${responseProjectTemplate.data.project_template_id}`),
          GenericGetResource(
            `/fieldtypes?filter=${utf8ToBase64(
              `field_type_nameLIKEformula|field_type_nameLIKEDate`
            )}`
          ),
        ];
        await Promise.all(myPromises)
          .then((responses) => {
            responses[0] && setProjectExtraFieldsTemplateData((prev) => responses[0].data.data);
          })
          .catch((error) => {
            showSnackBar(error.message, "error");
          });

        let myPermissions = [
          GetResourceByUrl(`/projectstemplate`),
        ];
        await Promise.all(myPermissions)
          .then((responsePermissions) => {
            responsePermissions[0] && setResourceScreen((prev) => responsePermissions[0]);
          })
          .catch((error) => {
            showSnackBar(error.message, "error");
          });
        setDataLoaded(true);
      })
      .catch((error) => {
        showSnackBar(error.message, "error");
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  useEffect(() => {
    GenericGetResource(
      `/fieldtypes?filter=${utf8ToBase64(
        `field_type_nameLIKEformula|field_type_nameLIKEDate`
      )}`
    )
      .then( (response) => {
        setComboFieldTypes(response.data.data)
      })
      .catch((error) => {
        showSnackBar(error.message, "error");
      });
  }, [])


  return (
    <>
      {!dataloaded && <Spinner />}
      {dataloaded && (
        <>
          <Header
            title={t("projectstemplate.title-view")}
            child={
              <div className="d-flex flex-row-reverse m-1">
                {resourceScreen?.delete === true && (
                  <ButtonStyled
                    variant="contained"
                    className="my-1"
                    onClick={() => setOpenDialog(true)}
                  >
                    {t("generic.buttons.delete")}
                  </ButtonStyled>
                )}
                <Button
                  variant="outlined"
                  onClick={() => {
                    navigate("/projectstemplate", { replace: true });
                  }}
                >
                  {t("generic.buttons.goback")}
                </Button>
              </div>
            }
          />
          <TabsProjectsTemplateDetails
            ProjectStagesTemplate={
              <TableProjectStagesTemplate
                project_template_id={projectsTemplateLocal?.project_template_id}
                comboFieldTypes={comboFieldTypes}
              />
            }
            ProjectExtraFieldsTemplate={
              <TableProjectExtraFieldsTemplate
                projectExtraFieldsTemplateData={projectExtraFieldsTemplateData}
                setProjectExtraFieldsTemplateData={setProjectExtraFieldsTemplateData}
                project_template_id={projectsTemplateLocal?.project_template_id ?? 0}
              />
            }
          />
        </>
      )}

      <GenericDialog
        title={t("generic.dialog.delete")}
        content={t("projecttypes.dialog.delete")}
        open={openDialog}
        setOpen={setOpenDialog}
        onAcept={onDelete}
      />
      <SnackbarComponent />
    </>
  );
};
